export const mapTypeToIcons = {
	task: 'document-pencil',
	visit: 'map-marker',
	news: 'newspaper',
}
